import doRequest from "api/utils/doRequest";
import gql from "graphql-tag";
import { useQuery } from "react-query";
import { CoachPermissions } from "api/coaches/mixins";
import { useDispatch } from "react-redux";

const listChannels = gql`
  query listChannels {
    listChannels {
      id
      name
      logoUrl
      lastLogin
      active
      status
      permissions {
        ...CoachPermissions
      }
    }
  }
  ${CoachPermissions()}
`;

export function useListChannels() {
  const dispatch = useDispatch();

  return useQuery(
    "listChannels",
    async () =>
      doRequest(
        {
          query: listChannels,
        },
        "data.listChannels"
      ),
    {
      refetchOnWindowFocus: false,
      onSuccess: (channels) => {
        if (channels) {
          const selected = channels.find((ch) => ch.active);

          dispatch({
            type: "SET_COMPANIES",
            payload: { list: channels, selected },
          });
        }
      },
    }
  );
}
